// src/pages/PrivacyPolicy.jsx
import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => (
  <div className="privacy-container">
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> April 17, 2026</p>

    <p>
      This Privacy Policy explains how PanelZero, Inc. (&quot;PanelZero,&quot; &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;)
      collects, uses, and safeguards information when you use our denial-management platform
      and related services (the &quot;Service&quot;).
    </p>

    <p>
      Protected Health Information (PHI) processed through PanelZero is governed by the
      Business Associate Agreement (BAA) signed with each covered entity. This policy
      describes how we handle non-PHI account and usage data.
    </p>

    <section>
      <h2>1. Information We Collect</h2>
      <h3>A. Account Information</h3>
      <ul>
        <li><strong>Identity Data:</strong> Name, work email, job title, and SSO identifiers.</li>
        <li><strong>Organization Data:</strong> Hospital / practice name, billing address, subscription status.</li>
      </ul>
      <h3>B. Usage &amp; System Data</h3>
      <ul>
        <li><strong>Log Data:</strong> IP address, browser, time zone, access times.</li>
        <li><strong>Activity:</strong> Metadata about how your team interacts with the denial queue, appeal drafts, and admin console.</li>
      </ul>
      <h3>C. Customer Data &amp; PHI</h3>
      <ul>
        <li>
          PHI flows through PanelZero strictly to deliver the Service (reading denials, generating appeals, and tracking submissions).
          It is processed under our BAA, encrypted in transit and at rest, and segregated per tenant with Postgres row-level security.
        </li>
      </ul>
    </section>

    <section>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li><strong>To provide the Service:</strong> authenticate users, generate appeals, submit filings, and track follow-ups.</li>
        <li><strong>Security &amp; compliance:</strong> detect anomalies, enforce access controls, maintain audit trails.</li>
        <li><strong>Support:</strong> respond to tickets and send administrative notices.</li>
        <li><strong>Improvement:</strong> analyze aggregated, de-identified patterns to improve model quality.</li>
      </ul>
    </section>

    <section>
      <h2>3. Cookies</h2>
      <p>We use only essential cookies for authentication and security. No advertising cookies, no data sales.</p>
    </section>

    <section>
      <h2>4. Data Sharing</h2>
      <ul>
        <li><strong>Subprocessors:</strong> hosting (Microsoft Azure, HIPAA-eligible regions), email (transactional only), and approved AI providers under BAA. A current subprocessor list is available on request.</li>
        <li><strong>The Customer:</strong> Administrators within your organization may access your usage logs and activity.</li>
        <li><strong>Legal:</strong> If compelled by law, subpoena, or to protect rights and safety.</li>
      </ul>
    </section>

    <section>
      <h2>5. Security &amp; Retention</h2>
      <p>TLS 1.2+ in transit, AES-256 at rest, tenant-scoped encryption keys, audit logs on every action. SOC 2 Type II in progress (letter of engagement available under NDA).</p>
      <p><strong>Retention:</strong> Customer Data is retained for the duration of the subscription. On termination, data is deleted or returned per the BAA / MSA.</p>
    </section>

    <section>
      <h2>6. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have rights to access, correct, or delete your personal data. Enterprise users should
        direct requests to their organization&apos;s administrator first; we will assist the Customer in fulfilling them.
      </p>
      {/* Restore when privacy@panelzero.com is live:
      <p>
        Contact <a href="mailto:privacy@panelzero.com">privacy@panelzero.com</a> with GDPR, CCPA, or HIPAA inquiries.
      </p>
      */}
    </section>

    <section>
      <h2>7. Updates</h2>
      <p>We may update this policy as the product evolves. Material changes are communicated by email or in-app notice.</p>
    </section>

    {/* Restore when privacy@panelzero.com is live:
    <section>
      <h2>Contact</h2>
      <p>
        Questions? Email <a href="mailto:privacy@panelzero.com">privacy@panelzero.com</a>.
      </p>
    </section>
    */}
  </div>
);

export default PrivacyPolicy;
